<div class="downtime_container">
  <div class="row">
    <div class="col-lg-10">
      <div class="image"></div>
    </div>
  </div>
</div>